module.exports = __webpack_public_path__ + "img/Stepping APA 1980.79377269.jpg";